/** @format */

import React from 'react';

export function designListUngroupedTableColumns(params) {
    const {handleToggleThumbnails, isShowingThumbnails} = params;

    return [
        {
            title: (
                <div className="table-column-title d-flex align-items-center justify-content-start">
                    <b className="m-0 p-0">Artwork</b>
                    <button
                        className="color-accent-primary ml-2 my-0 p-0"
                        onClick={handleToggleThumbnails}>
                        <u>{isShowingThumbnails ? 'Hide' : 'Show'}</u>
                    </button>
                </div>
            ),
            index: 'artwork',
            key: 'artwork'
        },
        {
            title: 'Type',
            index: 'type',
            key: 'type'
        },
        {
            title: 'Last Order ID',
            index: 'last_order_id',
            key: 'last_order_id'
        },
        {
            title: 'Date',
            index: 'date',
            key: 'date'
        },
        {
            title: 'Description',
            index: 'description',
            key: 'description'
        },
        {
            title: '',
            index: 'action',
            key: 'action'
        }
    ];
}
